<template>
  <div class="sm:w-full md:w4/5 lg:w-3/5 mx-auto md:p-6">
    <div class="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
      <!-- Header -->
      <div class="bg-gradient-to-r from-red-500 to-pink-500 px-6 py-4">
        <h2 class="text-xl font-semibold text-white">Edit Gift</h2>
        <p class="text-red-100 text-sm mt-1">Editing {{ gift.name }}...</p>
      </div>
      <!-- Gift Edit Form Card -->
      <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <form @submit.prevent class="space-y-6">
          <!-- Gift Name -->
          <div>
            <label for="giftName" class="block text-sm font-medium text-gray-700 mb-2">
              Gift Name
            </label>
            <input
v-model="giftForm.name" id="giftName" type="text"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors duration-200"
              placeholder="Enter gift name"
              maxlength="100"
>
          </div>

          <!-- Gift URL -->
          <div>
            <label for="giftUrl" class="block text-sm font-medium text-gray-700 mb-2">
              URL (Optional)
            </label>
            <input
v-model="giftForm.url" id="giftUrl" type="url"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors duration-200"
              placeholder="https://example.com/product"
              maxlength="2048"
>
            <p class="text-xs text-gray-500 mt-2">
              Link to where the gift can be purchased
            </p>
          </div>

          <!-- Gift Description -->
          <div>
            <label for="giftDescription" class="block text-sm font-medium text-gray-700 mb-2">
              Description (Optional)
            </label>
            <textarea
v-model="giftForm.description" id="giftDescription" rows="3"
              class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors duration-200"
              placeholder="Add any notes or details about this gift"
              maxlength="500"
></textarea>
          </div>

          <!-- Gift Price -->
          <div>
            <label for="giftPrice" class="block text-sm font-medium text-gray-700 mb-2">
              Price (Optional)
            </label>
            <div class="relative">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <span class="text-gray-500 text-sm">$</span>
              </div>
              <input
v-model="giftForm.price" id="giftPrice" type="number" step="0.01"
                class="w-full pl-8 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-red-500 transition-colors duration-200"
                placeholder="0.00"
>
            </div>
          </div>

          <!-- Gift Image Upload -->
          <div>
            <label for="giftImage" class="block text-sm font-medium text-gray-700 mb-2">
              Gift Image (Optional)
            </label>
            <div
              class="border-2 border-dashed border-gray-300 rounded-lg p-4 hover:border-gray-400 transition-colors duration-200"
>
              <input
@change="UpdateGiftImage()" id="giftImage" ref="giftImage" type="file" accept="image/*"
                class="w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-medium file:bg-red-50 file:text-red-600 hover:file:bg-red-100 transition-colors duration-200"
>
              <p class="text-xs text-gray-500 mt-2">
                We'll try to find an image automatically, but you can upload your own if needed
              </p>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="flex items-center justify-end space-x-3 pt-6 border-t border-gray-200">
            <button
type="button" @click="$router.go(-1)"
              class="px-6 py-2.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-200 transition-colors duration-200"
>
              Cancel
            </button>
            <button
@click="UpdateGift" type="button"
              class="px-6 py-2.5 text-sm font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2 transition-colors duration-200"
>
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { API, Storage } from 'aws-amplify';

import { updateGift } from '../graphql/mutations';

export default {
  name: "GiftEdit",
  props: {
    gift: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  components: {
  },
  computed: {
  },
  data() {
    return {
      giftForm: {},
      giftImage: this.gift.image,
    };
  },
  created() {
    this.giftForm = { ...this.gift }
  },
  watch: {
    gift(newGift) {
      if (Object.keys(this.gift).length === 0 && this.item.constructor === Object) {
        this.giftForm = newGift
      }
    },
  },
  methods: {
    removeImage() {
      this.giftImage = null;
    },
    async UpdateGiftImage() {
      const result = await Storage.put(
        this.gift.id + '.' + this.$refs.giftImage.files[0].name.split('.')[this.$refs.giftImage.files[0].name.split('.').length - 1],
        this.$refs.giftImage.files[0],
        { level: "public" });
      this.giftImage = result.key;
    },
    async UpdateGift() {
      if (this.giftForm.url != "" && this.giftForm.url != null) {
        if (!this.giftForm.url.includes("http")) {
          var url = 'https://' + this.giftForm.url;
        } else {
          var url = this.giftForm.url;
        }
      } else {
        var url = null;
      };

      if (this.giftImage.includes("gift.png") && this.giftForm.name != this.gift.name) {
        var giftImage = ''
      } else {
        var giftImage = this.giftImage;
      }
      const giftData = {
        id: this.gift.id,
        name: this.giftForm.name,
        description: this.giftForm.description,
        price: this.giftForm.price,
        url: url,
        image: giftImage,
      };
      try {
        const response = await API.graphql({ query: updateGift, variables: { input: giftData } });
        this.$router.go(-1)
      } catch (error) {
        console.log('Error creating gift...')
        console.log(error)
      }
    },
  },
};
</script>